import classNames from 'classnames'

import { ImageComponent } from '@apps-common/components/common/Image'

interface IProps {
  url: string
  classes: string
  alt: string
}

export const UnitProductCardImage: React.FC<IProps> = ({ url, classes, alt }) => (
  <div
    className={classNames(
      'w-[45px] h-[45px] rounded-[23px] border border-border flex items-center justify-center overflow-hidden',
      classes
    )}
  >
    <ImageComponent src={url} alt={alt} imageClasses={classNames('max-w-[30px]')} errorIconClasses='text-[1.2rem]' />
  </div>
)
